<template>
	<div>
		<van-nav-bar :title="$t('other.select_province')" class="nav-bar"></van-nav-bar>
		<div class="container">
			
			<van-tabs v-model="activeKey" sticky line-width='50'>
				<van-tab :title="$t('other.city')">
					<div class="content">
						<div class="box">
							{{obj.illustrate}}
						</div>
						<div v-for="item in obj.city" :key="item.id" class="contentItem"
							@click="$router.push({path:'/detail',query: {id:item.id,name: item.city}});">
							{{ item.city }}
						</div>
					</div>
				</van-tab>
				<van-tab :title="$t('other.about')">
					<div class="content">
						<div class="box">
						</div>
							{{obj.illustrate}}
						<div v-html="obj.describes">
						</div>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeKey: 0,
				obj: {}
			};
		},
		created() {
			this.beautyGetData()
		},

		methods: {
			beautyGetData() {
				this.$http({
					method: "get",
					url: "beautyGetData",
				}).then((res) => {
					if (res.code == 1) {
						console.log(res.data)
						this.obj = res.data;

					} else {
						this.$toast(res.msg);
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	::v-deep .van-tabs__wrap {
		height: 90px !important;
		margin-bottom: 10px;
	}

	::v-deep .van-tab {
		font-size: 32px !important;
		line-height: 100px !important
	}


	.container {
		background-color: #f2f2f5;

		.content {
			height: calc(100vh - 340px);
			padding: 20px;
			overflow-y: auto;
			scrollbar-width: none;
			-ms-overflow-style: none;

			.box {
				background-color: #8a637d;
				padding: 20px;
				font-size: 26px;
				color: #fff;
				margin-bottom: 20px;
				border-radius: 10px;
			}

			.contentItem {
				background-color: #fff;
				border-bottom: 1px solid #f2f2f5;
				padding: 30px;
				font-size: 26px;
			}
		}

	}
</style>